export { default as FolderRemoveSolidIcon } from './FolderRemoveSolidIcon';
